import { ExportedPayinsFilters } from './ExportedPayinsFilters';
import type { FiltersState } from './localState';

import { EXPORTED_PAYINS_HEADER_TEST_ID } from '../constants';

type ExportedPayinsHeaderProps = {
  filters: FiltersState;
  setFilters: (value: FiltersState) => void;
  resetState: () => void;
};

export const ExportedPayinsHeader = ({
  filters,
  setFilters,
  resetState
}: ExportedPayinsHeaderProps) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div
          className="text-2xl font-medium"
          data-testid={EXPORTED_PAYINS_HEADER_TEST_ID}
        >
          Exported pay-ins
        </div>
      </div>
      <ExportedPayinsFilters
        filters={filters}
        setFilters={setFilters}
        resetState={resetState}
      />
    </div>
  );
};
